module.exports = __webpack_public_path__ + "static/f050579e.BrazilBannerLeft.png";